import { addStyles } from "../../core/addStyles";

const useStyles = addStyles(() => ({
    rightColumn: {
        display: "flex",
        flexDirection: "column",
    },
    // Fills the right column so Definition matches the left column's height exactly:
    // zero-basis flex keeps it from growing the row; the absolute child stretches to fit.
    definitionFill: {
        position: "relative",
        flex: "1 1 0",
        minHeight: 0,
        "& > div": {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
        },
        "& .MuiInputBase-inputMultiline": {
            height: "100% !important",
            boxSizing: "border-box",
            overflowY: "auto",
        },
    },
}));

export { useStyles };
